export default "__VITE_ASSET__607ff21e__"